import { Application, ApplicationQuestion } from '@bybeam/platform-types';
import { isFieldEnabled } from '@platform-ui/utilities/application/fields/index.js';
import FieldReview from './FieldReview.js';

interface ApplicationQuestionReviewProps {
  application: Application;
  applicationQuestion: ApplicationQuestion;
}

export default function ApplicationQuestionReview({
  application,
  applicationQuestion,
}: ApplicationQuestionReviewProps): JSX.Element {
  const enabledFields = applicationQuestion.fields.filter((field) =>
    isFieldEnabled(field, application.answers),
  );

  return (
    <>
      {enabledFields.map((field) => {
        return (
          <FieldReview
            key={field.key}
            application={application}
            applicationQuestion={applicationQuestion}
            field={field}
          />
        );
      })}
    </>
  );
}
